import BillToolRun from '../components/tool/billing-tool-run';

export default BillToolRun;
